import { Spinner } from '@material-tailwind/react';
import React from 'react';

const Loading: React.FC = () => {
  return (
    <div className="flex flex-col items-center justify-center min-h-[100dvh] w-full">
      <Spinner 
        className="h-12 w-12" 
        onResize={undefined}
        onResizeCapture={undefined}
        onPointerEnterCapture={undefined}
        onPointerLeaveCapture={undefined}
      />
    </div>
  );
};

export default Loading;